// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageFilledSvg from "@fishx/icons-svg/es/asn/MessageFilled";
import FishxIcon from '../components/FishxIcon';

var MessageFilled = function MessageFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageFilledSvg
  }));
};

MessageFilled.displayName = 'MessageFilled';
export default React.forwardRef(MessageFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MessageFilled.js
// module id = 3128
// module chunks = 0